export const FAQ_INITIAL_STATE = "FAQ_INITIAL_STATE";
export const FAQ_FIND_STATE = "FAQ_FIND_STATE";